export const AMOBILE_BANK_ID = '01961ff4-6d64-7162-ad77-8ca988f1702f'
export const SBER_BANK_ID = 'b85b1c98-5307-46c6-9acb-5ca27a21b416'
export const T_BANK_ID = '2c72d88a-943c-4301-9f14-691ca9136aaf'
export const ALFA_BANK_ID = 'c6afa999-ada5-425e-b162-5c266fb68f5f'
export const VTB_BANK_ID = '40a07a0e-f46d-444d-b006-2d56ab39411b'
export const ESB_BANK_ID = '4923c332-b720-44a9-91ca-d95a039b6058'
export const RAIFFEISEN_BANK_ID = 'd7fb671e-3f33-4267-ae45-07bf48cb2fa5'
export const OZON_BANK_ID = '024c9d33-9a5c-42e1-8104-e34a2ca46391'
export const SOVCOM_BANK_ID = '953feac6-392c-4692-b2b5-c2ed9ffd9c5b'
export const SOLIDARNOST_BANK_ID = '953feac6-392c-4692-c2c6-c2ed9ffd9c5b'
export const WILDBERRIES_BANK_ID = '5fe78e45-299d-4d9e-97e1-4a8e3275e4c3'
export const YANDEX_BANK_ID = 'a8b78eb1-1e73-49fa-9abf-acf26b5cf69d'

export const VASL_BANK = '01961ff4-6d64-7162-ad88-8ca988f1702f'

export const AKB_BANK = '2526b044-957f-4604-b337-a41fa62683a5'
export const SPITAMEN_BANK = '01961ff4-6d64-7162-ad99-8ca988f1702f'
export const AMERIABANK_ID = '0e80dbaa-b2d7-4202-9b60-faa777a22f06'
export const MATIN_BANK = '953feac6-392c-4692-c3c8-c2ed9ffd9c5b'
export const M10_BANK = '953feac6-392c-4692-c3d1-c2ed9ffd9c5b'
export const BIRBANK = '953feac6-392c-4692-c3c9-c2ed9ffd9c5b'
export const IDRAM_BANK = '953feac6-392c-4692-c3c7-c2ed9ffd9c5b'